var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenexAvatar,{attrs:{"color":"#95d9ff"}},[_c('b-icon',{staticClass:"has-text-white",attrs:{"icon":"book-1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }